import {FieldArray, useField} from 'formik';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useState} from 'react';
import * as css from './Committees.css';
import CommitteesListPop from './CommitteesListPop';
import CommitteeRow from './CommitteeRow';
import useShow from '../../../../../hooks/useShow';
import BtnPlus from '../../../../../component/button/btnPlus/BtnPlus';
import {Committee, Club} from './CommitteesListPop.types';

function Committees() {
    const {t} = useTranslation('ticket');
    const [committeesField] = useField<Committee[]>('committees');
    const consumerClubs = useSelector((state: any) => state.account.consumerClubs);
    const show = useShow();
    const [editingIndex, setEditingIndex] = useState<number | undefined>(undefined);
    
    const availableClubs = consumerClubs?.filter((club: Club) => 
        !committeesField.value?.some((committee, index) => 
            (committee.clubId === club.clubId || committee.title === club.title) && 
            index !== editingIndex
        )
    ) || [];
    
    const hasAvailableClubsForNew = consumerClubs?.length > committeesField.value?.length;

    return (
        <>
            <FieldArray
                name="committees"
                render={(arrayHelpers) => {     
                    return (
                        <>
                            <css.committeesTitle>{t('committees')}</css.committeesTitle>
                            <css.committeesSection data-cy="Committees">
                                {committeesField.value?.map((committee, index) => (
                                    <CommitteeRow
                                        key={committee.clubId}
                                        index={index}
                                        onRemove={arrayHelpers.remove}
                                        onEdit={() => {
                                            setEditingIndex(index);
                                            show.open();
                                        }}
                                    />
                                ))}
                                {hasAvailableClubsForNew && (
                                    <css.addCommitteeButton>
                                        <BtnPlus 
                                        text="" 
                                        hasText={false} 
                                        white={false} 
                                        state={undefined} 
                                        bsize={30} 
                                        dataCyName="addCommittee" 
                                        onClick={() => {
                                            setEditingIndex(undefined);
                                            setImmediate(show.open);
                                        }}/>
                                        {t('addCommittee')}                     
                                    </css.addCommitteeButton>
                                )}
                            </css.committeesSection>
                            <CommitteesListPop 
                                show={show} 
                                arrayHelpers={arrayHelpers} 
                                availableClubs={availableClubs}
                                editingIndex={editingIndex}
                            />
                        </>
                    );
                }}
            />
        </>
    );
}

export default Committees;
